import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { faLock, faX } from '@fortawesome/free-solid-svg-icons';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
	selector: 'app-email-list-with-external-access-modal',
	templateUrl: './email-list-with-external-access-modal.component.html',
	styleUrls: ['./email-list-with-external-access-modal.component.scss']
})
export class EmailListWithExternalAccessModalComponent implements OnInit {
	@Input() emailsFromTheExternalLinks: { value: String, blocked: Boolean }[];
	@Input() htmlDescription: string;

	public modalResult: { value: String, blocked: Boolean }[];
	public icons: any = { 'lock': faLock, 'delete': faX };
	public form: FormGroup;

	constructor(
		private formBuilder: FormBuilder,
		public router: Router,
	) { }

	ngOnInit() {
		this.form = this.formBuilder.group({
			emailsFromTheExternalLinks: [this.emailsFromTheExternalLinks]
		});

		this.emailsFromTheExternalLinks = this.emailsFromTheExternalLinks.filter(element => !element.blocked);
	}

	public addEmail = (term: string) => {
		const email = term.trim();
		const emailsFromTheExternalLinks: any[] = this.form.controls.emailsFromTheExternalLinks.value || [];

		if (emailsFromTheExternalLinks.map((element: any) => element.value).includes(email)) return null;

		if (this.isValidEmail(email)) {
			return {
				value: email,
				blocked: false
			};
		}

		return null;
	};

	private isValidEmail(email: string): boolean {
		return /\S+@\S+\.\S+/.test(email);
	}

	public formSubmit(): void {
		this.modalResult = this.form.controls.emailsFromTheExternalLinks.value;
	}
}
